<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="contractApproval_cg commonListStyles">
            <van-nav-bar
                left-arrow
                left-text="应用"
                :style="`height: ${ $getNavHeight() }px;`"
                @click-left="swiperright"
            >
                <template #title>
                    <div :class="{'active': listType == 'db'}" @click="listSwitch('db')">
                        待审批
                    </div>
                    <div :class="{'active': listType == 'yb'}" @click="listSwitch('yb')">
                        已审批
                    </div>
                    <div :class="{'active': listType == 'cs'}" @click="listSwitch('cs')">
                        抄送
                    </div>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="value" placeholder="请输入搜索信息" @change="search"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        :immediate-check="false"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <template v-for="(item, index) in listData">
                                <li class="approval" :key="index">
                                    <div class="engineeringInfo">
                                        <h4 class="itemTitle">
                                            <span class="iconfont iconhetong">合同编号：{{ item.contract_no }}</span>
                                        </h4>
                                        <p class="itemStatus">
                                            {{ item.approval_status_name || item.status }}
                                        </p>
                                        <div class="itemContent">
                                            <p>
                                                <img src="@/assets/images/icons/icon_1@2x.png" alt="">
                                                <span>合同名称：{{ item.contract_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_4@2x.png" alt="">
                                                <span>供应商：{{ item.supplier_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                                <span>审批类型：{{ item.approval_type }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                                <span>经办部门：{{ item.dept_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                                <span>经办人：{{ item.operator_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                                <span>登记时间：{{ item.created || item.creation_time }}</span>
                                            </p>
                                            <template v-if="listType === 'db'">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_24@2x.png" alt="">
                                                    <span>当前环节：{{ item.BusinessPhaseName }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                                    <span>提交人：{{ item.preApproverName }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                                    <span>提交时间：{{ item.SubmitTime }}</span>
                                                </p>
                                            </template>
                                        </div>
                                        <div class="itemBtn itemBtns">
                                            <button v-if="listType === 'db'" @click="openApprovalProcess(item)">
                                                审批
                                            </button>
                                            <button v-if="listType === 'cs'" @click="openApprovalProcess(item, '', item.IsRead == 0 ? 'read' : 'view')">
                                                查阅
                                            </button>
                                            <button v-if="listType === 'yb'" @click="openApprovalProcess(item, 'see', 'view')">
                                                查看
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 合同审批
    name: 'contract-approval-cg',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path !== '/approvalProcess') {
            this.$store.commit('noKeepAlive', 'contract-approval-cg');
        }
        next();
    },
    data() {
        return {
            value: '',
            isLoading: false,
            isUpLoading: false,
            count: 0,
            total: 0,
            finished: false,
            listType: 'db',
            listData: [],
            typeCate: '',
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.isRefresh) {
            this.finished = false;
            this.listData = [];
            this.count = 0;
            this.gitListData();
        }
    },
    created() {
        this.init();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 首次加载
        async init() {
            this.typeCate = Math.floor(Math.random() * 1000000000000 + 1);
            this.$toast.loading({ overlay: true, duration: 0 });
            this.gitListData();
            this.$toast.clear();
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 搜索
        search() {
            this.count = 0;
            this.listData = [];
            this.finished = false;
            this.gitListData();
        },
        // 下拉刷新
        onRefresh() {
            this.count = 0;
            this.listData = [];
            this.gitListData();
        },
        // 上拉加载更多
        onLoad() {
            this.count++;
            this.gitListData();
        },
        // 待办已办切换
        listSwitch(obj) {
            this.count = 0;
            this.listData = [];
            this.listType = obj;
            this.finished = false;
            this.gitListData();
        },

        // 打开合同审批页
        openApprovalProcess(data, type, view) {
            data.BusinessInstanceId = data.business_instance_id;
            this.$router.isBack = 2;
            this.$router.push({
                name: 'approvalProcess',
                params: {
                    data: data,
                    isReadOnly: type === 'see' ? true : false,
                    view,
                },
            });
        },
        // 获取列表数据
        gitListData() {
            let queryCode = '';
            if (this.listType === 'db') {
                queryCode = 'procurement_contract_pending_approve';
            } else if (this.listType === 'yb') {
                queryCode = 'procurement_contract_approved';
            } else if (this.listType === 'cs') {
                queryCode = 'procurement_contract_approval_copy_list';
            }
            const params = {
                cacheKey: this.typeCate,
                code: queryCode,
                limit: 6,
                page: this.count,
                searchKey: this.value,
            };
            this.$axios.post('/interfaceApi/basicplatform/tabledata', params)
                .then(res => {
                    this.total = res.total;
                    this.listData.push(...res.rows || []);
                    this.finished = this.listData.length >= this.total;
                    this.isLoading = false;
                    this.isUpLoading = false;
                }) .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
};
</script>
<style lang="stylus">
.contractApproval_cg
    height 100%
    position relative
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
</style>
